module.exports = __webpack_public_path__ + "static/img/invest-health1.4bb4670.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-health1.jpg
// module id = EjSg
// module chunks = 0